module.exports = __webpack_public_path__ + "img/00027.5b3765bf.webp";